// src/components/GonePage.jsx
// Página semántica para contenido eliminado permanentemente (HTTP 410 Gone)
// Auditoría SEO Marzo 2026 - Limpieza de URLs deprecadas
import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Home, BookOpen } from 'lucide-react';
import SEOHead from './SEOHead';
import Navbar from './Navbar';

export default function GonePage() {
  return (
    <>
      <SEOHead
        title="Contenido Eliminado - Edutech Pulse Lab"
        description="Este contenido fue eliminado permanentemente y ya no está disponible."
        robots="noindex, noarchive, nosnippet"
      />
      <Navbar />

      <div className="min-h-[calc(100vh-var(--header-height-mobile))] md:min-h-[calc(100vh-var(--header-height-desktop))] bg-gradient-to-b from-gray-50 via-white to-gray-50 flex items-center justify-center px-4 pt-[112px] md:pt-[164px]">
        <div className="max-w-lg w-full text-center">

          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-amber-50 border-2 border-amber-200 mb-6">
              <AlertTriangle className="w-10 h-10 text-amber-500" />
            </div>

            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Contenido eliminado
            </h1>
            <p className="text-base md:text-lg text-gray-500 max-w-md mx-auto">
              Este contenido fue eliminado permanentemente y ya no está disponible en esta dirección.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-[#0c203b] text-white px-7 py-3.5 rounded-xl font-semibold text-sm shadow-md hover:bg-blue-900 transition-colors"
            >
              <Home className="w-4 h-4" />
              Ir al Inicio
            </Link>
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 border border-gray-300 text-gray-700 px-7 py-3.5 rounded-xl font-semibold text-sm hover:bg-gray-50 transition-colors"
            >
              <BookOpen className="w-4 h-4" />
              Ver el Blog
            </Link>
          </div>

          <p className="mt-10 text-xs text-gray-400">
            Si llegaste aquí desde un enlace externo, ese enlace ya no es válido.
          </p>
        </div>
      </div>
    </>
  );
}
